window.loading = false;
let myValCount = 0;
function addToBundle(){
    $('.mrk-add-product-to-bundle').unbind('click');
    $('.mrk-add-product-to-bundle').click(function (e) { 
        e.preventDefault();
        const btn = $(this);
        btn.attr('aria-busy', true);
        const title = btn.attr('title');
        const product_id = btn.attr('product_id');
        myValCount = myValCount + 1;
        countitem = `${myValCount}/${window.number_of_products}`;
        setTimeout(function(){
            btn.attr('aria-busy', false);
            disableButton(btn);
            const item = `<div class="product-item" title="${title}" product_id="${product_id}">
                <div class="product-content">
                    <div class="product-title h5 tes"><span class="text-grey">${myValCount}.</span> ${title}</div>
                    <div class="product-remove-btn link text-xs"><svg role="presentation" stroke-width="2" focusable="false" width="20" height="20" class="icon icon-close" viewBox="0 0 24 24">
        <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
      </svg></div>                                
                </div>
            </div>`;
            $('.mrk-bundle-items').append(item);
            updateCounter(window.number_of_products,myValCount)
            checkBundle();
            removeAction();
        },200)
    });
}
function updateCounter(total,current){
    $('.mrk-progress-counter').each(function() {
        const percent = (current * 100) / total;
        $(this).css({'--value': percent})
        $(this).find('.mrk-inner-progress').text(`${current}/${total}`);
    });
}
function disableButton(btn){
    btn.prop('disabled', true).css('background-color','green');
    console.log(!btn.hasClass('product-card__mobile-quick-buy-button'));
    if(!btn.hasClass('product-card__mobile-quick-buy-button')){
    btn.find('div').text('Added!');
    }

}
function enableButton(btn){
    if(!btn.hasClass('product-card__mobile-quick-buy-button')){
        btn.find('div').text('ADD TO QUEUE'); 
    }
    btn.prop('disabled', false).css('background-color','rgb(var(--button-background))');
}
function checkBundle(){
    if($('.product-item').length > 0){
        $('.mrk-selected-products .empty-text').hide() 
    }else{
        $('.mrk-selected-products .empty-text').show()
    }
    if($('.product-item').length == window.number_of_products * 2){
        $('.mrk-final-add-subscribe').show().prop('disabled', false);
        $('.mrk-add-product-to-bundle').each(function(){
            $(this).addClass('disabled');
        });
        openSubscriptionDrawer();
    }else{
        $('.mrk-final-add-subscribe').show().prop('disabled', true);
        $('.mrk-add-product-to-bundle').each(function(){
            $(this).removeClass('disabled');
        }); 
    }
}
function removeAction(){
    $('.product-remove-btn').unbind('click');
    $('.product-remove-btn').click(function (e) { 
        e.preventDefault();
        const product_id = $(this).parents('.product-item').attr('product_id')
       // $(`.product-item[product_id="${product_id}"]`).each(function(){$(this).remove()});
        myValCount -= 1; // Decrease myValCount by 1
        $(`.product-item[product_id="${product_id}"]`).each(function(){
            $(this).remove();
        });
        updateCounter(window.number_of_products,myValCount)
        updateProductTitles();
        checkBundle();
        updateButtons()
    });
}

function updateProductTitles() {
    // Loop through all product items and update their titles
    $('.collection__facets-scroller .product-item').each(function (index) {
        const title = $(this).attr('title');
        $(this).find('.product-title').html(`${index + 1}. ${title}`);
    });
}
function openSubscriptionDrawer(){
    var products_names = '';
    $('.collection__facets-scroller .product-item').each(function(index,item) { 
         var title = $(this).attr('title');
         
         var item = `<input type="hidden" name="properties[${index+1}]" value="${title}">`;
         products_names = products_names + item;
    });
    $('.mrk-custom-attributes').html('').html(products_names);
    document.querySelector('subscription-buy-drawer').show();
};

$(document).on('mrk:addToCart',function(){
    document.querySelector('subscription-buy-drawer').hide();
    document.querySelector('tester-drawer').hide();
    document.querySelector('facet-drawer').hide();
  
});
$(document).on('mrk:filterStart',function(){
    window.mrk_selected_bundle = $('.mrk-bundle-items').html()
});
$(document).on('mrk:filterLoaded',function(){
    $('.mrk-bundle-items').html(window.mrk_selected_bundle);
    addToBundle();
    checkBundle();
    updateButtons();
    checkScroll();
    removeAction();
    mrkAllReloads();
    updateCounter(window.number_of_products,myValCount)
});


function mrkAllReloads(){
    $('.mrk-search-form [type="reset"]').on('click', function(){
        setTimeout(function(){
            $('.mrk-search-form input[type="search"]').trigger('input');
        },150)
    });
    $('.mrk-final-add-subscribe').click(openSubscriptionDrawer);
    $('.mrk-search-form').on('submit', function(e){
        e.preventDefault();
        $('.mrk-search-form input[type="search"]').trigger('input')
    });
    $('.mrk-search-form input[type="search"]').on('input', function(e) {
        $('.mrk-subscription-page').addClass('is-loading');
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(function() {
            if (requestInProgress) {
                return;
            }
            e.preventDefault();
            var form = $('.mrk-search-form');
            if($('.mrk-search-form input[type="search"]').val().length>0){
                var url = form.attr('action') + '?' + form.serialize();
                requestInProgress = true;
                $.ajax({
                    url: url,
                    method: 'get',
                    complete: function() {
                        requestInProgress = false;
                    },
                    success: function(response) {
                        var html = $.parseHTML(response);
                        const products = $(html).filter('.mrk-products').html();
                        const pagination = $(html).filter('.pagination').html();
                        $('.mrk-product-list').html(products);
                        $('.mrk-pagination').html(pagination);
                        $('.mrk-subscription-page').removeClass('is-loading');
                        addToBundle();
                        checkBundle();
                        updateButtons();
                        checkScroll();
                        if(products == ''){
                            $('.mrk-empty').show()
                        }else{
                            $('.mrk-empty').hide()
                        }
                    }
                });
            }else{
                var url = location.pathname+location.search;
                $('.mrk-subscription-page').addClass('is-loading');
                requestInProgress = true;
                $.ajax({
                    url: url,
                    method: 'get',
                    complete: function() {
                        requestInProgress = false;
                    },
                    success: function(response) {
                        var html = $.parseHTML(response);
                        const products = $(html).find('.mrk-product-list').html();
                        const pagination = $(html).find('.mrk-pagination').html();
                        $('.mrk-product-list').html(products);
                        $('.mrk-pagination').html(pagination);
                        $('.mrk-subscription-page').removeClass('is-loading');
                        addToBundle();
                        checkBundle();
                        updateButtons();
                        checkScroll();
                        if(products == ''){
                            $('.mrk-empty').show()
                        }else{
                            $('.mrk-empty').hide()
                        }
                    }
                });
            }
        }, 1000);  
    });
    $('[aria-controls="tester-drawer"]').click(function(){
        document.querySelector('tester-drawer').show();
    })
}
var debounceTimeout;
var requestInProgress = false;


function updateButtons(){
    $('.mrk-add-product-to-bundle').each(function(){
        enableButton($(this));
    });
    $('.product-item').each(function(){
        const product_id = $(this).attr('product_id');
        $(`.mrk-add-product-to-bundle[product_id=${product_id}]`).each(function(){
            disableButton($(this));
        });
    });
    updatedCounts();
}
function updateData(){
    $('.mrk-bundle-items').each(function(){
        $(this).html('');
        checkBundle();
        updateButtons();
    });
    updatedCounts();
}
function updatedCounts(){
    $('[role="dialog"] .mrk-bundle-items .product-item .product-title .text-grey').each(function(index){
        var order = index + 1;
        $(this).html(`${order}.`);
    });
}

//function mrkPagination(){
    //window.loading = true;
   // $('.mrk-subscription-page').addClass('is-loading');
   // $.ajax({
        //url: $('.mrk-loader').attr('next-url'),
        //method: 'get',
        //success: function(response) {
          // window.loading = false;
           //var html = $.parseHTML(response);
           // const products = $(html).find('.mrk-product-list').html();
           // const pagination = $(html).find('.mrk-pagination').html();
           // $('.mrk-product-list').append(products);
           // $('.mrk-pagination').html(pagination);
           // $('.mrk-subscription-page').removeClass('is-loading'); 
          //  addToBundle();
          //  checkBundle();
          //  updateButtons();
          //  checkScroll()
      //  }
  //  });
//}

function mrkPagination() {
    if (window.loading) return;

    const nextUrl = $('.mrk-loader').attr('next-url');
    if (!nextUrl) return;

    window.loading = true;
    $('.mrk-subscription-page').addClass('is-loading');

    $.get(nextUrl, function (response) {

        const $response = $('<div>').html(response);

        const products = $response.find('.mrk-product-list').html();
        const pagination = $response.find('.mrk-pagination').html();

        if (products) {
            $('.mrk-product-list').append(products);
        }

        if (pagination) {
            $('.mrk-pagination').html(pagination);
        }

        $('.mrk-subscription-page').removeClass('is-loading');

        addToBundle();
        updateButtons();

        window.loading = false;

        checkScroll();
    });
}


//function checkScroll() {
    //if ($('.mrk-pagination').length && $('.mrk-loader').attr('next-url') != undefined) {
        //$(window).on('scroll', function(){
            //if ($(window).scrollTop() + $(window).height() >= $(document).height() - 500 && $('.mrk-loader').attr('next-url') != undefined && window.loading == false) {
                //$(window).off('scroll');
                //mrkPagination();
            //}
        //});
    //} else {
        //$('.mrk-loader').hide();
    //}    
//}

function checkScroll() {

    const loader = document.querySelector('.mrk-loader');
    if (!loader) return;

    if (window.mrkObserver) {
        window.mrkObserver.disconnect();
    }

    window.mrkObserver = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && !window.loading) {
            mrkPagination();
        }
    }, {
        rootMargin: '300px'
    });

    window.mrkObserver.observe(loader);
}

updateCounter(window.number_of_products,0);
checkScroll();
addToBundle();
mrkAllReloads();


// Fix for load more button
$(document).on('click', '.mrk-load-more-btn', function() {
    const nextUrl = $('.mrk-loader').attr('next-url');
    if (nextUrl && window.loading == false) {
        mrkPagination();
    }
});
